import React from 'react'

import {
  TagComponent,
  Icon,
  Verified,
  SuccessFilled,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

function SubscriberStatus({ productPrice, isRestructure = false }) {
  return (
    <div className="subscriber-status">
      <div className="subscriber-status__price-row">
        <span className="subscriber-status__free-price">$0</span>
        <span className="subscriber-status__original-price">{productPrice}</span>
        <TagComponent
          type="ghost"
          backColor="brand-primary-20"
          className={classnames('subscriber-status__badge', isRestructure && 'subscriber-status__badge--restructure')}
        >
          <Icon
            svgComponent={isRestructure ? SuccessFilled : Verified}
            size="tiny"
            notSpaced
            className="subscriber-status__badge-icon"
          />
          Included in Subscription
        </TagComponent>
      </div>
    </div>
  )
}

SubscriberStatus.propTypes = {
  productPrice: string.isRequired,
  isRestructure: bool,
}

export default SubscriberStatus
